import { render, staticRenderFns } from "./LanhuCarousel.vue?vue&type=template&id=5c00cdb0&scoped=true"
import script from "./LanhuCarousel.vue?vue&type=script&lang=js"
export * from "./LanhuCarousel.vue?vue&type=script&lang=js"
import style0 from "./LanhuCarousel.vue?vue&type=style&index=0&id=5c00cdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c00cdb0",
  null
  
)

export default component.exports